import { Alert } from 'antd';
import styled from 'styled-components';

// Note(Anson Kan): Do we have a variable for 2.5rem? or is it in the design system already?
export const ShortfallAlert = styled(Alert)`
  margin-bottom: 2.5rem;
`;
